import { render, staticRenderFns } from "./sendMSG.vue?vue&type=template&id=6bfe7c3a&"
import script from "./sendMSG.vue?vue&type=script&lang=js&"
export * from "./sendMSG.vue?vue&type=script&lang=js&"
import style0 from "./sendMSG.vue?vue&type=style&index=0&id=6bfe7c3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports